import type { AppointmentPhotos, PhotoMetadata } from "./evidence";
import { photoContentType, photoContentTypeOfExtension, type PhotoContentType } from "./photo-types";

export type SlotPhotoMetadata = { photo_captured_at?: string; lat?: number; lng?: number };

export type SlotPhotoRow = {
  id: string;
  appointment: string;
  user: string | null;
  workflow: string;
  image: string;
  is_after: boolean;
  meta_data?: SlotPhotoMetadata | null;
  created_at: string;
  updated_at: string;
};

export const PHOTO_CACHE_CONTROL = "max-age=3600";

export const slotPhotoMetadata = ({ takenAt, latitude, longitude }: PhotoMetadata): SlotPhotoMetadata => ({
  ...(takenAt === undefined ? {} : { photo_captured_at: takenAt }),
  ...(latitude === undefined ? {} : { lat: latitude }),
  ...(longitude === undefined ? {} : { lng: longitude }),
});

export const takenPhotoMetadata = ({ photo_captured_at, lat, lng }: SlotPhotoMetadata): PhotoMetadata => ({
  ...(photo_captured_at === undefined ? {} : { takenAt: photo_captured_at }),
  ...(lat === undefined ? {} : { latitude: lat }),
  ...(lng === undefined ? {} : { longitude: lng }),
});

export const toAppointmentWorkflows = (appointmentId: string, { items }: AppointmentPhotos): SlotPhotoRow[] =>
  items.map((photo) => ({
    id: photo.id,
    appointment: appointmentId,
    user: photo.by?.id ?? null,
    workflow: photo.workflow,
    image: photo.url,
    is_after: photo.side === "after",
    meta_data: slotPhotoMetadata(photo.metadata),
    created_at: photo.at,
    updated_at: photo.at,
  }));

const extensionOf = (name: string | null | undefined): string => (name?.split("?")[0]?.split(".").pop() ?? "").toLowerCase();

export function photoContentTypeFor(declaredType: string | null | undefined, ...names: (string | null | undefined)[]): PhotoContentType {
  const declared = photoContentType.safeParse(declaredType);
  if (declared.success) return declared.data;
  for (const name of names) {
    const known = photoContentTypeOfExtension(extensionOf(name));
    if (known !== undefined) return known;
  }
  return "image/jpeg";
}
